//DATA
export const ADD_PROPERTY = 'ADD_PROPERTY';
export const ADD_PLACEHOLDER = 'ADD_PLACEHOLDER';
export const REMOVE_PROPERTY = 'REMOVE_PROPERTY';
export const REORDER_PROPERTY = 'REORDER_PROPERTY';
export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const SELECT_PROPERTY = 'SELECT_PROPERTY';
export const SET_TEMPLATES = 'SET_TEMPLATES';
export const TEMPLATE_SAVED = 'TEMPLATE_SAVED';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const SET_TEMPLATE = 'SET_TEMPLATE';
export const RESET_TEMPLATE = 'RESET_TEMPLATE';

//UI
export const EDIT_PROPERTY = 'EDIT_PROPERTY';
export const SET_THESAURIS = 'SET_THESAURIS';
export const SHOW_REMOVE_PROPERTY_CONFIRM = 'SHOW_REMOVE_PROPERTY_CONFIRM';
export const HIDE_REMOVE_PROPERTY_CONFIRM = 'HIDE_REMOVE_PROPERTY_CONFIRM';
export const SAVING_TEMPLATE = 'SAVING_TEMPLATE';